module.exports = __webpack_public_path__ + "img/hmpg-right-blueshare.a2c35d73.svg";